import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { ChoferModel } from 'src/app/models/solicitud/ChoferModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import * as fileSaver from 'file-saver';
import { SolicitudVehiculoDocumentosService } from 'src/app/services/solicitud-vehiculo-documentos/solicitud-vehiculo-documentos.service';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';

@Component({
  selector: 'app-vehiculo-readonly-dialog',
  templateUrl: './vehiculo-readonly-dialog.component.html',
  styleUrls: ['./vehiculo-readonly-dialog.component.css']
})
export class VehiculoReadonlyDialogComponent implements OnInit {
  model: ISolicitudVehiculoModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento'
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<VehiculoReadonlyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISolicitudVehiculoModel,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private solicitudVehiculoDocumentoService: SolicitudVehiculoDocumentosService,
  ) {
    this.model = new VehiculoModel();
  }

  ngOnInit(): void {
    this.solicitudVehiculoService.getById(this.data.idSolicitud, this.data.idSolicitudVehiculo).subscribe(p => {
      // console.log(p);
      this.model = p;
      this.model.idSolicitud = this.data.idSolicitud;
      this.model.codigoSolicitud = this.data.codigoSolicitud;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);

      if (!this.model.solicitudChofer) {
        this.model.solicitudChofer = new ChoferModel();
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Vehiculos;
      modelVisor.idRegistro = this.model.idSolicitudVehiculo;
      modelVisor.idSolicitudDocumento = element.idSolicitudVehiculoDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudVehiculoDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.model.idSolicitudVehiculo,
        element.idSolicitudVehiculoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
